import { defineComponent as h, createElementBlock as t, createCommentVNode as r, openBlock as l, normalizeProps as g, mergeProps as m, unref as o, normalizeClass as d, createStaticVNode as p, createElementVNode as v, reactive as f } from "vue";
import { useBindCx as u, cva as c } from "@scalar/use-hooks/useBindCx";
const z = {
  key: 0,
  class: "circular-loader"
};
function x() {
  return f({
    isValid: !1,
    isInvalid: !1,
    isLoading: !1,
    startLoading() {
      this.isLoading = !0;
    },
    stopLoading() {
      this.isLoading = !1;
    },
    validate(e = 800, s) {
      this.isInvalid = !1, this.isValid = !0;
      const i = s ? e - 300 : e;
      return new Promise(
        (a) => setTimeout(s ? () => this.clear().then(() => a(!0)) : () => a(!0), i)
      );
    },
    invalidate(e = 1100, s) {
      this.isValid = !1, this.isInvalid = !0;
      const i = s ? e - 300 : e;
      return new Promise(
        (a) => setTimeout(s ? () => this.clear().then(() => a(!0)) : () => a(!0), i)
      );
    },
    clear(e = 300) {
      return this.isValid = !1, this.isInvalid = !1, this.isLoading = !1, new Promise((s) => {
        setTimeout(() => {
          s(!0);
        }, e);
      });
    }
  });
}
const S = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "ScalarLoading",
  props: {
    loadingState: {},
    size: {}
  },
  setup(e) {
    const { cx: s } = u(), i = c({
      variants: {
        size: {
          xs: "size-3",
          sm: "size-3.5",
          md: "size-4",
          lg: "size-5",
          xl: "size-6",
          "2xl": "size-8",
          "3xl": "size-10",
          full: "size-full"
        }
      },
      defaultVariants: {
        size: "full"
      }
    });
    return (a, n) => a.loadingState ? (l(), t("div", g(m({ key: 0 }, o(s)("loader-wrapper", o(i)({ size: a.size })))), [
      (l(), t("svg", {
        class: d(["svg-loader", {
          "icon-is-valid": a.loadingState.isValid,
          "icon-is-invalid": a.loadingState.isInvalid
        }]),
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [
        n[0] || (n[0] = p('<path class="svg-path svg-check-mark" d="m 0 60 l 30 30 l 70 -80" data-v-f525638b></path><path class="svg-path svg-x-mark" d="m 50 50 l 40 -40" data-v-f525638b></path><path class="svg-path svg-x-mark" d="m 50 50 l 40 40" data-v-f525638b></path><path class="svg-path svg-x-mark" d="m 50 50 l -40 -40" data-v-f525638b></path><path class="svg-path svg-x-mark" d="m 50 50 l -40 40" data-v-f525638b></path>', 5)),
        a.loadingState.isLoading ? (l(), t("g", z, [
          v("circle", {
            class: d(["loader-path", {
              "loader-path-off": a.loadingState.isValid || a.loadingState.isInvalid
            }]),
            cx: "50",
            cy: "50",
            fill: "none",
            r: "20",
            "stroke-width": "3"
          }, null, 2)
        ])) : r("", !0)
      ], 2))
    ], 16)) : r("", !0);
  }
});
export {
  S as default,
  x as useLoadingState
};
